module.exports = __webpack_public_path__ + "media/images/games/35gender/stuffedanimals-cf652ccdf26cddd0baa48a84e6417503.png";